import { CoursewareItemProvider, UserService } from 'services';
import { pendoModule } from './pendo';

export const loadPendoScript = () => {
  const pearsonUid = window.piSession?.userId() || '';
  if (!document.getElementById('learnspace-pendo-tracker')) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'learnspace-pendo-tracker';
    script.defer = true;
    script.text = pendoModule(pearsonUid, window.appConfig.getPendoApiKey());
    document.head.appendChild(script);
  }
};

export const pendoInitialize = async (deploymentId, coursewareItemId) => {
  if (window.pendoModule && window.piSession) {
    const pearsonUid = window.piSession.userId();
    const user = await UserService.build().getUser();
    const bronteActivityName = await CoursewareItemProvider.getInCoursewareState(coursewareItemId, ['title']);
    window.pendoModule.pendoInitialize({
      id: pearsonUid,
      // eslint-disable-next-line
      bronteActivityId: deploymentId,
      userRole: user?.roles?.[0]?.toLowerCase() || '',
      integrationType: 'MLM',
      platform: 'Bronte',
      bronteActivityName,
      // Can send the below info if needed
      // account: {
      //     // id: ‘ACCOUNT-UNIQUE-ID’ // Highly recommended
      //     // name: // Optional
      //     // planLevel: // Optional
      //     // planPrice: // Optional
      //     // creationDate: // Optional
      //     // You can add any additional account level key-values here, // as long as it’s not one of the above reserved names.
      // },
    });
  } else {
    // eslint-disable-next-line
    console.log('Pendo script not loaded, or consent not given.');
  }
};
